import * as angular from 'angular';
import template from './failedChecks.tpl.html';
import controller from './failedChecks.controller';

export default angular.module('aps.directive.failedChecks', [controller])
  .directive('apsFailedChecks', failedChecksDef)
  .name;

function failedChecksDef() {
  return {
    restrict: 'E',
    template: template,
    replace: true,
    controller: 'FailedChecksCtrl',
    controllerAs: 'vm',
    bindToController: true,
    scope: {}
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/checkLists/failedChecks.directive.ts